import React, { useState, useEffect } from 'react';

import DeleteButton from '../../../../../DeleteButton';

import renderFormInputs from '../../../../../../helpers/renderFormInputs';
import useScheduledPaymentForm from '../../../../../../forms/loan/scheduledPayment';
import { useUiContext } from '../../../../../../context/UiContext';

export default function ScheduledPayment({
  payment,
  createOrupdateScheduledPayment,
  deleteScheduledPayment,
  isSubmitDisabled,
  disabled,
  removeEmptyScheduledPayment,
  isLender,
}) {
  const [readOnly, setReadOnly] = useState(true);

  const { showDialogModal } = useUiContext();

  useEffect(() => {
    setTimeout(() => {
      setReadOnly(false);
    }, 100);
  }, [isLender]);

  const form = useScheduledPaymentForm(
    createOrupdateScheduledPayment,
    payment,
    disabled
  );

  return (
    <fieldset>
      <legend className="text-slate-800 dark:text-slate-100 font-bold mb-3 flex justify-between w-full text-base">
        {payment.isNew ? 'Add Payment' : `Payment #${payment.key + 1}`}{' '}
        {!payment.isNew && !disabled && !isLender && (
          <DeleteButton
            trashCanIcon
            onClick={() => {
              if (isSubmitDisabled) {
                return;
              }

              showDialogModal({
                type: 'danger',
                title: 'Are you sure want to delete this payment?',
                onConfirm: () => deleteScheduledPayment(payment.key),
              });
            }}
          />
        )}
      </legend>
      <div className="grid gap-5 md:grid-cols-3 xl:grid-cols-4">
        {renderFormInputs({
          fields: form.fields[0].fields,
          formik: form.formik,
          prevGroupsSize: 0,
          isVisible: true,
          tabindex: 0,
          readOnly: readOnly || disabled,
        })}
        <div>
          <div className="flex items-center gap-2 mb-1">
            <span
              className="block text-sm font-medium"
              htmlFor="amount_to_principal"
            >
              &nbsp;
            </span>
          </div>
          {!isLender && (
            <div className="flex gap-5">
              <button
                onClick={form.formik.handleSubmit}
                type="button"
                className="btn dark:bg-slate-800 border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600 text-indigo-500 h-9"
              >
                Save
              </button>
              {payment.isNew && (
                <button
                  type="button"
                  className="underline bg-transparent border-none text-blue-500 hover:text-blue-700 focus:outline-none dark:text-blue-300 dark:hover:text-blue-500 h-9 text-sm"
                  onClick={() => removeEmptyScheduledPayment(payment.key)}
                >
                  Cancel
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </fieldset>
  );
}
